module.exports = __webpack_public_path__ + "img/01.2d873b8c.png";